import React from "react";
import { LandingPageShell } from "./layout/LandingPageShell";
import { PageTemplate } from "../PageTemplate/PageTemplate";

/*
 * This file is the main entry point for the landing page.
 * It can be used to set up any necessary context providers or global state for the landing page,
 *  and then render the LandingPageShell which contains the actual layout and content of the page.
 */

export const LandingPage: React.FC = () => (
  <PageTemplate data-id="landing-page">
    <LandingPageShell />
  </PageTemplate>
);
